<template>
   <v-dialog 
    v-model="activeMode"  
    max-width="800"
    @click:outside="closeForm()"
    scrollable
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-btn color="primary" v-on="on">Выбрать работы</v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Форма выбора работ</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="mt-7">
        <v-alert
          v-if="Boolean(error)"
          type="error"
          dense
          outlined
        >{{ error }}</v-alert>
        <v-data-table
          class="elevation-1"
          :items="items"
          :headers="tblHeaders"
          disable-pagination
          hide-default-footer
        >
          <template v-if="items.length > 0" v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item._id" 
                
              >
                <td>
                  <v-checkbox
                    v-if="item.itemType == 'service'"
                    v-model="item.isActive"
                    @change="item.isActive ? (item.count = 1) : (item.count = 0)"
                  ></v-checkbox>
                </td>
                <td :colspan="item.itemType == 'service' ? 1 : 3" @click="!item.isActive ? ((item.isActive = 1) && (item.count = 1)) : false">
                  <template v-if="item.itemType == 'service'">{{ item.name }}</template>
                  <template v-if="item.itemType == 'subCategory'"><strong>{{ item.name }}</strong></template>
                  <template v-if="item.itemType == 'category'"><strong>{{ item.name.toUpperCase() }}</strong></template>
                </td>
                <td v-if="item.itemType == 'service'" @click="!item.isActive ? ((item.isActive = 1) && (item.count = 1)) : false">
                  {{ item.unitName }}
                </td>
                <td v-if="item.itemType == 'service'" @click="!item.isActive ? ((item.isActive = 1) && (item.count = 1)) : false">
                  <input 
                    v-model="item.count" 
                    :class="{error: !isNumber(item.count)}"
                    :disabled="!item.isActive"
                    style="width: 50px; border: 1px solid gray;"
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
   </v-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'services-list',

  props: {
    value: Array,
  },

  data() {
    return {
      activeMode: false,
      error: false,
      items: [],
      tblHeaders: [{text: ''}, {text: 'Наименование'}, {text: 'Ед.изм.'}, {text: 'Кол-во'}]
    }
  },

  created() {
    this.init();
  }, 

  watch: {
    value() {
      this.init();
    }
  },

  methods: {
    scrollUp() {
      let modals = document.getElementsByClassName('v-dialog--active');
      if (modals.length > 0) {
        let cards = modals[modals.length - 1].getElementsByClassName('v-card__text');
        if (cards.length > 0) {
          cards[0].scrollTop = 0;
        }
      }
    },
    init() {
      let items = [];
      let prev = null;
      for (let serv of this.value) {
        if (!prev || prev.categoryName != serv.categoryName) {
          items.push({
            _id: this.getTempId(),
            itemType: 'category',
            name: serv.categoryName.toUpperCase()
          });
        }
        if (!prev || prev.categoryName != serv.categoryName || prev.subCategoryName != serv.subCategoryName) {
          items.push({
             _id: this.getTempId(),
            itemType: 'subCategory',
            name: serv.subCategoryName
          });
        }
        items.push({
          _id: this.getTempId(),
            itemType: 'service',
            name: serv.name,
            unitName: serv.unitName,
            categoryName: serv.categoryName,
            subCategoryName: serv.subCategoryName,
            count: Boolean(serv.count) ? serv.count : 0,
            isActive: Boolean(serv.count)
        });
        prev = serv;
      }
      //console.log(items);
      this.items = items;
    },
    save() {
      for (let item of this.items) {
        if (item.itemType == 'service' && !this.isNumber(item.count)) {
          this.error = 'Исправьте ошибки ввода - кол-во должно быть числом.';
          this.scrollUp();
          return;
        }
      }
      let savedItems = this.items.filter(x => x.itemType == 'service');
      this.$emit('input', savedItems);
      this.$nextTick(() => this.closeForm());
    },
    closeForm() {
      this.scrollUp();
      this.activeMode = false;
      this.init();
      this.error = false;
    }
  }
}
</script>